<template>
  <div class="public-page">
    <PublicNavbar />
    <slot />
    <PublicFooter />
  </div>
</template>
<script>
import PublicNavbar from "./PublicNavbar";
import PublicFooter from "./PublicFooter";
export default {
  name: "Layout",
  components: {
    PublicNavbar,
    PublicFooter,
  },
};
</script>